import moment from 'moment';

const convertEndDate = (item) => {
    if (item.termless) {
        return new Date("2050-01-01");
    }

    return new Date(moment(item.endDate).format('YYYY-MM-DD 23:59:59'));
};
const convertStartDate = (startDate) => {
    if (startDate) {
        const d = new Date(startDate);
        d.setHours(0,0,0,0)
        return d
    }
    return null
};

const transformItem = (item) => {
    return {
        id: item._id,
        startDate: convertStartDate(item.startDate),
        propertyId: item.propertyId,
        status: item.status,
        endDate: convertEndDate(item),
        termless: Boolean(item.termless),
        creatorType: item.creatorType,
        statusComment: item.statusComment,
        bookingId: item.bookingId,
        tenantName: (item.tenant && item.tenant.name)
            ? item.tenant.name
            : '',
        tenantSurname: (item.tenant && item.tenant.surname)
            ? item.tenant.surname
            : '',
        createdAt: item.createdAt,
        updatedAt: item.updatedAt,
    };
};

export default {
    transform(data) {
        if (!Array.isArray(data)) {
            return [];
        }
        const result = [];
        data.forEach(item => {
            result.push(transformItem(item));
        });

        return result;
    }
}



// WEBPACK FOOTER //
// ./src/transformers/input/property-calendar/index.js